import { render, staticRenderFns } from "./firstYearIndex.vue?vue&type=template&id=ca69014e&scoped=true"
import script from "./firstYearIndex.vue?vue&type=script&lang=js"
export * from "./firstYearIndex.vue?vue&type=script&lang=js"
import style0 from "./firstYearIndex.vue?vue&type=style&index=0&id=ca69014e&prod&lang=scss&scoped=true"
import style1 from "./firstYearIndex.vue?vue&type=style&index=1&id=ca69014e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca69014e",
  null
  
)

export default component.exports